import { render, staticRenderFns } from "./SortBox.vue?vue&type=template&id=3708f266&scoped=true"
import script from "./SortBox.vue?vue&type=script&lang=js"
export * from "./SortBox.vue?vue&type=script&lang=js"
import style0 from "./SortBox.vue?vue&type=style&index=0&id=3708f266&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708f266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3708f266')) {
      api.createRecord('3708f266', component.options)
    } else {
      api.reload('3708f266', component.options)
    }
    module.hot.accept("./SortBox.vue?vue&type=template&id=3708f266&scoped=true", function () {
      api.rerender('3708f266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SortBox.vue"
export default component.exports